// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#sectionFour-wrapper {
  display: flex;
  width: 100%;
  flex-direction: column;
  background: #fff;
}
#sectionFour-wrapper .sectionFour-client {
  padding: 50px 0;
}
#sectionFour-wrapper .sectionFour-client .heading {
  font-family: Roboto;
  font-style: normal;
  font-weight: 600;
  font-size: 43px;
  line-height: 32.5px;
  color: #1c2640;
  text-align: center;
  padding: 0;
}
#sectionFour-wrapper .sectionFour-client .clientImg {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 50px;
  margin-bottom: 50px;
  padding: 0 75px;
}
#sectionFour-wrapper .sectionFour-client .clientImg img {
  width: 85%;
}
#sectionFour-wrapper .sectionFour-client .stories-link {
  text-align: center;
}
#sectionFour-wrapper .sectionFour-client .stories-link a {
  font-family: Roboto;
  font-size: 20px;
  font-weight: 500;
  line-height: 23.44px;
  color: #EC6927;
}
#sectionFour-wrapper #sectionFour {
  padding: 60px 0 100px;
  background: rgba(157, 170, 241, 0.32);
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
#sectionFour-wrapper #sectionFour #sectionFour-Head {
  font-family: Roboto;
  font-size: 43px;
  font-weight: 600;
  line-height: 32.5px;
  text-align: center;
  color: #1C2640;
  text-align: center;
  margin: 0 0 20px;
  padding: 0;
}
#sectionFour-wrapper #sectionFour .btn-contact {
  width: 121px;
  height: 33px;
  border-radius: 3px;
  background: #EC6927;
  border: #EC6927;
  box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.2509803922);
  font-family: Roboto;
  font-size: 13.5px;
  font-weight: 400;
  line-height: 20px;
  text-align: center;
  color: #fff;
  margin-top: 80px;
}
#sectionFour-wrapper #sectionFour .card-wrapper {
  display: flex;
  gap: 2em;
  margin-top: 50px;
}
#sectionFour-wrapper #sectionFour .card-wrapper .card-one-section-four,
#sectionFour-wrapper #sectionFour .card-wrapper .card-two-section-four,
#sectionFour-wrapper #sectionFour .card-wrapper .card-three-section-four {
  padding: 50px 30px;
  width: 33%;
  background: #fff;
  width: 357px;
  height: 573px;
  gap: 0px;
  border-radius: 6px;
  box-shadow: 0px 5px 4px 0px rgba(196, 196, 196, 0.6);
}
#sectionFour-wrapper #sectionFour .card-wrapper .card-one-section-four .header,
#sectionFour-wrapper #sectionFour .card-wrapper .card-two-section-four .header,
#sectionFour-wrapper #sectionFour .card-wrapper .card-three-section-four .header {
  font-family: Roboto;
  font-size: 32px;
  font-weight: 700;
  line-height: 40px;
  text-align: center;
}
#sectionFour-wrapper #sectionFour .card-wrapper .card-one-section-four .lines,
#sectionFour-wrapper #sectionFour .card-wrapper .card-two-section-four .lines,
#sectionFour-wrapper #sectionFour .card-wrapper .card-three-section-four .lines {
  border: 1px solid #D9D9D9;
  margin-top: 30px;
}
#sectionFour-wrapper #sectionFour .card-wrapper .card-one-section-four .content,
#sectionFour-wrapper #sectionFour .card-wrapper .card-two-section-four .content,
#sectionFour-wrapper #sectionFour .card-wrapper .card-three-section-four .content {
  margin-top: 50px;
}
#sectionFour-wrapper #sectionFour .card-wrapper .card-one-section-four .content .list,
#sectionFour-wrapper #sectionFour .card-wrapper .card-two-section-four .content .list,
#sectionFour-wrapper #sectionFour .card-wrapper .card-three-section-four .content .list {
  display: flex;
  align-items: center;
  gap: 1em;
  font-family: Inter;
  font-size: 21px;
  font-weight: 400;
  line-height: 30px;
  text-align: left;
  margin-bottom: 40px;
}
#sectionFour-wrapper #sectionFour .card-wrapper .card-four-section-four {
  padding: 50px 30px;
  background: #fff;
  height: 409px;
  width: 1137px;
  gap: 0px;
  border-radius: 6px;
  box-shadow: 0px 5px 4px 0px rgba(196, 196, 196, 0.6);
  border-top: 33px solid #1C2640;
}
#sectionFour-wrapper #sectionFour .card-wrapper .card-four-section-four .header {
  color: #1C2640;
  font-family: Roboto;
  font-size: 32px;
  font-weight: 700;
  line-height: 40px;
  text-align: center;
  margin-bottom: 40px;
}
#sectionFour-wrapper #sectionFour .card-wrapper .card-four-section-four .content {
  display: flex;
  align-items: start;
  gap: 1em;
  margin-bottom: 70px;
}
#sectionFour-wrapper #sectionFour .card-wrapper .card-four-section-four .content .list {
  width: 25%;
  font-family: Inter;
  font-size: 21px;
  font-weight: 400;
  line-height: 30px;
  text-align: left;
  display: flex;
  align-items: baseline;
  gap: 0.5em;
}
#sectionFour-wrapper #sectionFour .card-wrapper .card-one-section-four {
  border-top: 33px solid #EC6927;
}
#sectionFour-wrapper #sectionFour .card-wrapper .card-one-section-four .header {
  color: #EC6927;
}
#sectionFour-wrapper #sectionFour .card-wrapper .card-two-section-four {
  border-top: 33px solid #E7B051;
}
#sectionFour-wrapper #sectionFour .card-wrapper .card-two-section-four .header {
  color: #E7B051;
}
#sectionFour-wrapper #sectionFour .card-wrapper .card-three-section-four {
  border-top: 33px solid #9DAAF1;
}
#sectionFour-wrapper #sectionFour .card-wrapper .card-three-section-four .header {
  color: #9DAAF1;
}
#sectionFour-wrapper #sectionFour #sectionFour-Head-Text {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 150.19%;
  text-align: center;
  color: #52667c;
  width: 80%;
  padding: 0;
  margin: 0 0 30px;
}
#sectionFour-wrapper #sectionFour #sectionFour-Head-link {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 23px;
  color: #ec6927;
  padding: 0;
  margin: 0;
}
#sectionFour-wrapper #sectionFour .sectionFour-content-box {
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-top: 100px;
  padding: 0 180px;
}
#sectionFour-wrapper #sectionFour .sectionFour-content-box .sectionFour-content-box-left {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 50%;
}
#sectionFour-wrapper #sectionFour .sectionFour-content-box .sectionFour-content-box-left .sectionFour-content-box-left-heading {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 36px;
  line-height: 20px;
  color: #1c2640;
  margin-top: 30px;
  margin-bottom: 30px;
}
#sectionFour-wrapper #sectionFour .sectionFour-content-box .sectionFour-content-box-left .sectionFour-content-box-left-list {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 23px;
  color: #435569;
  padding-left: 20px;
}
#sectionFour-wrapper #sectionFour .sectionFour-content-box .sectionFour-content-box-left .sectionFour-content-box-left-list li {
  margin-bottom: 15px;
}
#sectionFour-wrapper #sectionFour .sectionFour-content-box .sectionFour-content-box-right {
  display: flex;
  flex-direction: row;
  width: 50%;
  align-items: center;
  justify-content: left;
  position: relative;
  margin-left: 80px;
}
#sectionFour-wrapper #sectionFour .sectionFour-content-box .sectionFour-content-box-right .sectionFour-content-box-right-img {
  width: 100%;
  max-width: 420px;
  height: auto;
}
#sectionFour-wrapper #sectionFour .sectionFour-content-box .sectionFour-content-box-right .discount-card {
  width: 100%;
  max-width: 140px;
  height: auto;
  position: absolute;
  top: -25px;
  left: 30px;
}
#sectionFour-wrapper #sectionFour .sectionFour-content-box-rev {
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-top: 100px;
  padding: 0 180px;
}
#sectionFour-wrapper #sectionFour .sectionFour-content-box-rev .sectionFour-content-box-rev-left {
  display: flex;
  flex-direction: row;
  width: 50%;
  align-items: center;
  position: relative;
}
#sectionFour-wrapper #sectionFour .sectionFour-content-box-rev .sectionFour-content-box-rev-left .sectionFour-content-box-rev-left-img {
  width: 100%;
  max-width: 420px;
  height: auto;
}
#sectionFour-wrapper #sectionFour .sectionFour-content-box-rev .sectionFour-content-box-rev-left .discount-card {
  width: 100%;
  max-width: 140px;
  height: auto;
  position: absolute;
  top: -25px;
  left: 30px;
}
#sectionFour-wrapper #sectionFour .sectionFour-content-box-rev .sectionFour-content-box-rev-right {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 50%;
}
#sectionFour-wrapper #sectionFour .sectionFour-content-box-rev .sectionFour-content-box-rev-right .sectionFour-content-box-rev-right-heading {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 36px;
  line-height: 20px;
  color: #1c2640;
  margin-bottom: 30px;
  margin-top: 30px;
}
#sectionFour-wrapper #sectionFour .sectionFour-content-box-rev .sectionFour-content-box-rev-right .sectionFour-content-box-rev-right-list {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 23px;
  color: #435569;
  padding-left: 20px;
}
#sectionFour-wrapper #sectionFour .sectionFour-content-box-rev .sectionFour-content-box-rev-right .sectionFour-content-box-rev-right-list li {
  margin-bottom: 15px;
}`, "",{"version":3,"sources":["webpack://./src/components/Home/SectionFour/sectionFour.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;AACD;AACC;EACC,eAAA;AACF;AAAE;EACC,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;AAEH;AAAE;EACC,aAAA;EACG,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACH,eAAA;AAEH;AADM;EACC,UAAA;AAGP;AAAE;EACC,kBAAA;AAEH;AADG;EACC,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,cAAA;AAGJ;AACC;EACC,qBAAA;EACA,qCAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;AACF;AACE;EACC,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;AACH;AAEE;EACC,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,uDAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;AAAH;AAGE;EACI,aAAA;EACA,QAAA;EACA,gBAAA;AADN;AAEM;;;EAGC,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;EACH,aAAA;EACA,QAAA;EACA,kBAAA;EACA,oDAAA;AAAJ;AACI;;;EACC,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAGL;AADI;;;EACC,yBAAA;EACA,gBAAA;AAKL;AAHI;;;EACC,gBAAA;AAOL;AANK;;;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AAUN;AAHM;EACC,kBAAA;EACA,gBAAA;EACH,aAAA;EACA,aAAA;EACA,QAAA;EACA,kBAAA;EACA,oDAAA;EAUG,8BAAA;AAJP;AALI;EACI,cAAA;EACA,mBAAA;EACH,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AAOL;AAJO;EACC,aAAA;EACA,kBAAA;EACA,QAAA;EACA,mBAAA;AAMR;AALQ;EACC,UAAA;EACA,kBAAA;EACH,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACG,qBAAA;EACA,UAAA;AAOT;AADM;EAIC,8BAAA;AAAP;AAHO;EACC,cAAA;AAKR;AADG;EAIC,8BAAA;AAAJ;AAHI;EACC,cAAA;AAKL;AADG;EAIC,8BAAA;AAAJ;AAHI;EACC,cAAA;AAKL;AACE;EACC,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;EACA,UAAA;EACA,gBAAA;AACH;AAEE;EACC,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;EACA,SAAA;AAAH;AAGE;EACC,aAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;AADH;AAGG;EACC,aAAA;EACA,sBAAA;EAEA,uBAAA;EACA,UAAA;AAFJ;AAII;EACC,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AAFL;AAKI;EACC,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AAHL;AAKK;EACC,mBAAA;AAHN;AAQG;EACC,aAAA;EACA,mBAAA;EACA,UAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;AANJ;AAQI;EACC,WAAA;EACA,gBAAA;EACA,YAAA;AANL;AASI;EACC,WAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;AAPL;AAYE;EACC,aAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;AAVH;AAYG;EACC,aAAA;EACA,mBAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;AAVJ;AAaI;EACC,WAAA;EACA,gBAAA;EACA,YAAA;AAXL;AAcI;EACC,WAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;AAZL;AAgBG;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,UAAA;AAdJ;AAgBI;EACC,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AAdL;AAiBI;EACC,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AAfL;AAiBK;EACC,mBAAA;AAfN","sourcesContent":["#sectionFour-wrapper {\n\tdisplay: flex;\n\twidth: 100%;\n\tflex-direction: column;\n\tbackground: #fff;\n\t\n\t.sectionFour-client{\n\t\tpadding: 50px 0;\n\t\t.heading{\n\t\t\tfont-family: Roboto;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 600;\n\t\t\tfont-size: 43px;\n\t\t\tline-height: 32.5px;\n\t\t\tcolor: #1c2640;\n\t\t\ttext-align: center;\n\t\t\tpadding: 0;\n\t\t}\n\t\t.clientImg{\n\t\t\tdisplay: flex;\n    \t\talign-items: center;\n    \t\tjustify-content: center;\n    \t\tmargin-top: 50px;\n    \t\tmargin-bottom: 50px;\n\t\t\tpadding: 0 75px;\n    \t\timg{\n    \t\t\twidth: 85%;\n    \t\t}\n\t\t}\n\t\t.stories-link{\n\t\t\ttext-align: center;\n\t\t\ta{\n\t\t\t\tfont-family: Roboto;\n\t\t\t\tfont-size: 20px;\n\t\t\t\tfont-weight: 500;\n\t\t\t\tline-height: 23.44px;\n\t\t\t\tcolor: #EC6927;\n\t\t\t}\n\t\t}\n\t}\n\t#sectionFour {\n\t\tpadding: 60px 0 100px;\n\t\tbackground: rgba(157, 170, 241, 0.32);\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\twidth: 100%;\n\n\t\t#sectionFour-Head {\n\t\t\tfont-family: Roboto;\n\t\t\tfont-size: 43px;\n\t\t\tfont-weight: 600;\n\t\t\tline-height: 32.5px;\n\t\t\ttext-align: center;\n\t\t\tcolor: #1C2640;\n\t\t\ttext-align: center;\n\t\t\tmargin: 0 0 20px;\n\t\t\tpadding: 0;\n\t\t}\n\n\t\t.btn-contact{\n\t\t\twidth: 121px;\n\t\t\theight: 33px;\n\t\t\tborder-radius: 3px;\n\t\t\tbackground: #EC6927;\n\t\t\tborder:#EC6927;\n\t\t\tbox-shadow: 2px 2px 4px 0px #00000040;\n\t\t\tfont-family: Roboto;\n\t\t\tfont-size: 13.5px;\n\t\t\tfont-weight: 400;\n\t\t\tline-height: 20px;\n\t\t\ttext-align: center;\n\t\t\tcolor: #fff;\n\t\t\tmargin-top: 80px;\n\t\t}\n\n\t\t.card-wrapper {\n\t\t    display: flex;\n\t\t    gap: 2em;\n\t\t    margin-top: 50px;\n\t\t    .card-one-section-four ,\n\t\t    .card-two-section-four ,\n\t\t    .card-three-section-four {\n\t\t    \tpadding: 50px 30px;\n\t\t    \twidth: 33%;\n\t\t    \tbackground: #fff;\n\t\t    \twidth: 357px;\n\t\t\t\theight: 573px;\n\t\t\t\tgap: 0px;\n\t\t\t\tborder-radius: 6px;\n\t\t\t\tbox-shadow: 0px 5px 4px 0px #C4C4C499;\n\t\t\t\t.header{\n\t\t\t\t\tfont-family: Roboto;\n\t\t\t\t\tfont-size: 32px;\n\t\t\t\t\tfont-weight: 700;\n\t\t\t\t\tline-height: 40px;\n\t\t\t\t\ttext-align: center;\n\t\t\t\t}\n\t\t\t\t.lines{\n\t\t\t\t\tborder: 1px solid #D9D9D9;\n\t\t\t\t\tmargin-top: 30px;\n\t\t\t\t}\n\t\t\t\t.content{\n\t\t\t\t\tmargin-top: 50px;\n\t\t\t\t\t.list{\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tgap: 1em;\n\t\t\t\t\t\tfont-family: Inter;\n\t\t\t\t\t\tfont-size: 21px;\n\t\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\t\tline-height: 30px;\n\t\t\t\t\t\ttext-align: left;\n\t\t\t\t\t\tmargin-bottom: 40px;\n\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t    }\n\n\t\t    .card-four-section-four {\n\t\t    \tpadding: 50px 30px;\n\t\t    \tbackground: #fff;\n\t\t\t\theight: 409px;\n\t\t\t\twidth: 1137px;\n\t\t\t\tgap: 0px;\n\t\t\t\tborder-radius: 6px;\n\t\t\t\tbox-shadow: 0px 5px 4px 0px #C4C4C499;\n\t\t\t\t.header{\n\t\t    \t\tcolor: #1C2640;\n\t\t    \t\tfont-family: Roboto;\n\t\t\t\t\tfont-size: 32px;\n\t\t\t\t\tfont-weight: 700;\n\t\t\t\t\tline-height: 40px;\n\t\t\t\t\ttext-align: center;\n\t\t\t\t\tmargin-bottom: 40px;\n\t\t    \t}\n\t\t    \tborder-top: 33px solid #1C2640;\n\t\t    \t.content {\n\t\t    \t\tdisplay: flex;\n\t\t    \t\talign-items: start;\n\t\t    \t\tgap: 1em;\n\t\t    \t\tmargin-bottom: 70px;\n\t\t    \t\t.list{\n\t\t    \t\t\twidth: 25%;\n\t\t    \t\t\tfont-family: Inter;\n\t\t\t\t\t\tfont-size: 21px;\n\t\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\t\tline-height: 30px;\n\t\t\t\t\t\ttext-align: left;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t    align-items: baseline;\n\t\t\t\t\t    gap: 0.5em;\n\n\t\t    \t\t}\n\t\t    \t}\n\t\t    }\n\n\t\t    .card-one-section-four {\n\t\t    \t.header{\n\t\t    \t\tcolor: #EC6927;\n\t\t    \t}\n\t\t    \tborder-top: 33px solid #EC6927;\n\t\t    }\n\t\t\t.card-two-section-four {\n\t\t\t\t.header{\n\t\t\t\t\tcolor: #E7B051;\n\t\t\t\t}\n\t\t\t\tborder-top: 33px solid #E7B051;\n\t\t\t}\n\t\t\t.card-three-section-four {\n\t\t\t\t.header{\n\t\t\t\t\tcolor: #9DAAF1;\n\t\t\t\t}\n\t\t\t\tborder-top: 33px solid #9DAAF1;\n\t\t\t}\n\t\t}\n\n\t\t#sectionFour-Head-Text {\n\t\t\tfont-family: Roboto;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: normal;\n\t\t\tfont-size: 18px;\n\t\t\tline-height: 150.19%;\n\t\t\ttext-align: center;\n\t\t\tcolor: #52667c;\n\t\t\twidth: 80%;\n\t\t\tpadding: 0;\n\t\t\tmargin: 0 0 30px;\n\t\t}\n\n\t\t#sectionFour-Head-link {\n\t\t\tfont-family: Roboto;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 500;\n\t\t\tfont-size: 20px;\n\t\t\tline-height: 23px;\n\t\t\tcolor: #ec6927;\n\t\t\tpadding: 0;\n\t\t\tmargin: 0;\n\t\t}\n\n\t\t.sectionFour-content-box {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: row;\n\t\t\twidth: 100%;\n\t\t\tmargin-top: 100px;\n\t\t\tpadding: 0 180px;\n\n\t\t\t.sectionFour-content-box-left {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\t// align-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t\twidth: 50%;\n\n\t\t\t\t.sectionFour-content-box-left-heading {\n\t\t\t\t\tfont-family: Roboto;\n\t\t\t\t\tfont-style: normal;\n\t\t\t\t\tfont-weight: bold;\n\t\t\t\t\tfont-size: 36px;\n\t\t\t\t\tline-height: 20px;\n\t\t\t\t\tcolor: #1c2640;\n\t\t\t\t\tmargin-top: 30px;\n\t\t\t\t\tmargin-bottom: 30px;\n\t\t\t\t}\n\n\t\t\t\t.sectionFour-content-box-left-list {\n\t\t\t\t\tfont-family: Roboto;\n\t\t\t\t\tfont-style: normal;\n\t\t\t\t\tfont-weight: normal;\n\t\t\t\t\tfont-size: 18px;\n\t\t\t\t\tline-height: 23px;\n\t\t\t\t\tcolor: #435569;\n\t\t\t\t\tpadding-left: 20px;\n\n\t\t\t\t\tli {\n\t\t\t\t\t\tmargin-bottom: 15px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.sectionFour-content-box-right {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: row;\n\t\t\t\twidth: 50%;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: left;\n\t\t\t\tposition: relative;\n\t\t\t\tmargin-left: 80px;\n\n\t\t\t\t.sectionFour-content-box-right-img {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\tmax-width: 420px;\n\t\t\t\t\theight: auto;\n\t\t\t\t}\n\n\t\t\t\t.discount-card {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\tmax-width: 140px;\n\t\t\t\t\theight: auto;\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttop: -25px;\n\t\t\t\t\tleft: 30px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.sectionFour-content-box-rev {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: row;\n\t\t\twidth: 100%;\n\t\t\tmargin-top: 100px;\n\t\t\tpadding: 0 180px;\n\n\t\t\t.sectionFour-content-box-rev-left {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: row;\n\t\t\t\twidth: 50%;\n\t\t\t\talign-items: center;\n\t\t\t\tposition: relative;\n\n\n\t\t\t\t.sectionFour-content-box-rev-left-img {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\tmax-width: 420px;\n\t\t\t\t\theight: auto;\n\t\t\t\t}\n\n\t\t\t\t.discount-card {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\tmax-width: 140px;\n\t\t\t\t\theight: auto;\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttop: -25px;\n\t\t\t\t\tleft: 30px;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.sectionFour-content-box-rev-right {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\tjustify-content: center;\n\t\t\t\twidth: 50%;\n\n\t\t\t\t.sectionFour-content-box-rev-right-heading {\n\t\t\t\t\tfont-family: Roboto;\n\t\t\t\t\tfont-style: normal;\n\t\t\t\t\tfont-weight: bold;\n\t\t\t\t\tfont-size: 36px;\n\t\t\t\t\tline-height: 20px;\n\t\t\t\t\tcolor: #1c2640;\n\t\t\t\t\tmargin-bottom: 30px;\n\t\t\t\t\tmargin-top: 30px;\n\t\t\t\t}\n\n\t\t\t\t.sectionFour-content-box-rev-right-list {\n\t\t\t\t\tfont-family: Roboto;\n\t\t\t\t\tfont-style: normal;\n\t\t\t\t\tfont-weight: normal;\n\t\t\t\t\tfont-size: 18px;\n\t\t\t\t\tline-height: 23px;\n\t\t\t\t\tcolor: #435569;\n\t\t\t\t\tpadding-left: 20px;\n\n\t\t\t\t\tli {\n\t\t\t\t\t\tmargin-bottom: 15px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
